import React from "react";
import MobileAppLinks from "../mobileAppLinks";
import { useCopies } from "../../hooks/useCopies";
import { FeatureControlCheckArgsType } from "./type";
import useFeatureControlCheckService from "./service";

function FeatureControlCheck(props: FeatureControlCheckArgsType) {
  const copies = useCopies();
  const service = useFeatureControlCheckService(props);

  if (service.showMobileAppDownloadLinks) {
    return (
      <MobileAppLinks
        headerLogo={props.headerLogo}
        appStoreLink={props.mobileAppLinks?.appStoreLink}
        playStoreLink={props.mobileAppLinks?.playStoreLink}
      />
    );
  } else if (service.isIEBrowser) {
    return (
      <div className="featureNotAvailable_wrapper">
        <div className="featureNotAvailable_content">{copies.get("browser.not.supported")}</div>
      </div>
    );
  }
  return <React.Fragment>{props.children}</React.Fragment>;
}

export default FeatureControlCheck;
